import React, { ReactElement } from "react";
import { errorAlertStyle } from "./alertStyles";

interface Props extends React.HTMLProps<HTMLDivElement> {
  children: ReactElement | string;
}

export default function ErrorAlert({
  children,
  className,
  ...htmlProps
}: Props) {
  return (
    <div className={`${errorAlertStyle} ${className ?? ""}`} {...htmlProps}>
      <div className="col-span-full text-sm font-semibold text-gray-900 mb-0">
        {children}
      </div>
    </div>
  );
}
